<template>
  <layout-component>
    <div class="container">
      <div class="row form-wrapper pb-4 pb-md-2">
        <div class="col-md-7 col-lg-8 form form-login">
          <h1 class="br-title left-bullet" v-html="$t('title-banner')"></h1>
          <p class="br-title p-intro mr-lg-5 pr-lg-5" v-html="$t('subtitle-01')"></p>
          <div class="row">
            <div class="col-lg-9">
              <b-alert :show="has_error && !success" fade variant="danger">
                <template v-if="error == 'registration_validation_error'">
                  <h4><i class="fal fa-times"></i> {{'error-title-01'|t}}</h4>
                  <p>{{'error-text-01'|t}}</p>
                </template>
                <template v-else>
                  <h4><i class="fal fa-times"></i> {{'error-title-02'|t}}</h4>
                  <p>{{'error-text-02'|t}}</p>
                </template>
              </b-alert>

              <form autocomplete="off" @submit.prevent="register" v-if="!success" method="post">
                <h3 v-html="$t('title-01')"></h3>
                <div class="row">
                  <div class="col-sm">
                    <div class="form-group" :class="{ 'has-error': has_error && errors.name }">
                        <label for="register-name">{{'label-firstname'|t}} <span class="required">*</span></label>
                        <div class="input-wrapper">
                          <input type="text" id="register-name" class="form-control" placeholder="Peter" v-model="name">
                          <span class="focus-border"></span>
                        </div>
                        <small class="form-text text-danger" v-if="has_error && errors.name" v-html="errors.name.join('<br />')"></small>
                    </div>
                  </div>
                  <div class="col-sm">
                    <div class="form-group" :class="{ 'has-error': has_error && errors.surname }">
                        <label for="register-surname">{{'label-lastname'|t}} <span class="required">*</span></label>
                        <div class="input-wrapper">
                          <input type="text" id="register-surname" class="form-control" placeholder="Parker" v-model="surname">
                          <span class="focus-border"></span>
                        </div>
                        <small class="form-text text-danger" v-if="has_error && errors.surname" v-html="errors.surname.join('<br />')"></small>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm">
                    <div class="form-group" :class="{ 'has-error': has_error && errors.email }">
                        <label for="register-email">{{'label-email'|t}} <span class="required">*</span></label>
                        <div class="input-wrapper">
                          <input type="email" id="register-email" class="form-control" placeholder="user@example.com" v-model="email">
                          <span class="focus-border"></span>
                        </div>
                        <small class="form-text text-danger" v-if="has_error && errors.email" v-html="errors.email.join('<br />')"></small>
                    </div>
                  </div>
                  <div class="col-sm">
                    <div class="form-group" :class="{ 'has-error': has_error && errors.email }">
                        <label for="register-email_confirmation">{{'label-email-confirmation'|t}} <span class="required">*</span></label>
                        <div class="input-wrapper">
                          <input type="email" id="register-email_confirmation" class="form-control" placeholder="user@example.com" v-model="email_confirmation">
                          <span class="focus-border"></span>
                        </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm">
                    <div class="form-group" :class="{ 'has-error': has_error && errors.password }">
                        <label for="register-password">{{'label-password'|t}} <span class="required">*</span></label>
                        <div class="input-wrapper">
                          <input type="password" id="register-password" class="form-control" v-model="password">
                          <span class="focus-border"></span>
                        </div>
                        <small class="form-text text-danger" v-if="has_error && errors.password" v-html="errors.password.join('<br />')"></small>
                    </div>
                  </div>
                  <div class="col-sm">
                    <div class="form-group" :class="{ 'has-error': has_error && errors.password }">
                        <label for="register-password_confirmation">{{'label-password-confirmation'|t}} <span class="required">*</span></label>
                        <div class="input-wrapper">
                          <input type="password" id="register-password_confirmation" class="form-control" v-model="password_confirmation">
                          <span class="focus-border"></span>
                        </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group" :class="{ 'has-error': has_error && errors.phone }">
                        <label for="register-phone">{{'label-phone-number'|t}} <span class="required">*</span></label>
                        <div class="input-wrapper">
                          <input type="text" id="register-phone" class="form-control" placeholder="+352 123456789" v-model="phone">
                          <span class="focus-border"></span>
                        </div>
                        <small class="form-text text-danger" v-if="has_error && errors.phone" v-html="errors.phone.join('<br />')"></small>
                    </div>
                  </div>
                </div>

                <h3 v-html="$t('title-02')"></h3>
                <div class="row">
                  <div class="col-sm">
                    <div class="form-group" :class="{ 'has-error': has_error && errors.company }">
                        <label for="register-company">{{'label-company-name'|t}} <em>{{'label-optional'|t}}</em></label>
                        <div class="input-wrapper">
                          <input type="text" id="register-company" class="form-control" placeholder="Daily Bugle" v-model="company">
                          <span class="focus-border"></span>
                        </div>
                        <small class="form-text text-danger" v-if="has_error && errors.company" v-html="errors.company.join('<br />')"></small>
                    </div>
                  </div>
                  <div class="col-sm">
                    <div class="form-group" :class="{ 'has-error': has_error && errors.vat }">
                        <label for="register-vat">{{'label-vat-number'|t}} <em v-if="!company">{{'label-optional'|t}}</em></label>
                        <div class="input-wrapper">
                          <input type="text" id="register-vat" class="form-control" placeholder="LU12345678" v-model="vat">
                          <span class="focus-border"></span>
                        </div>
                        <small class="form-text text-danger" v-if="has_error && errors.vat" v-html="errors.vat.join('<br />')"></small>
                    </div>
                  </div>
                </div>

                <template v-if="!isApp">
                <h3 v-html="$t('title-03')"></h3>
                <div class="row">
                  <div class="col-sm">
                    <div class="form-group" :class="{ 'has-error': has_error && errors.address }">
                        <label for="register-address">{{'label-address'|t}} <span class="required">*</span></label>
                        <div class="input-wrapper">
                          <input type="text" id="register-address" class="form-control" placeholder="115c, rue Emile Mark" v-model="address">
                          <span class="focus-border"></span>
                        </div>
                        <small class="form-text text-danger" v-if="has_error && errors.address" v-html="errors.address.join('<br />')"></small>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm">
                    <div class="form-group" :class="{ 'has-error': has_error && errors.address2 }">
                        <label for="register-address2">{{'label-address-supplement'|t}} <em>{{'label-optional'|t}}</em></label>
                        <div class="input-wrapper">
                          <input type="text" id="register-address2" class="form-control" v-model="address2">
                          <span class="focus-border"></span>
                        </div>
                        <small class="form-text text-danger" v-if="has_error && errors.address2" v-html="errors.address2.join('<br />')"></small>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm">
                    <div class="form-group" :class="{ 'has-error': has_error && errors.postcode }">
                        <label for="register-postcode">{{'label-postcode'|t}} <span class="required">*</span></label>
                        <div class="input-wrapper">
                          <input type="text" id="register-postcode" class="form-control" placeholder="4620" v-model="postcode">
                          <span class="focus-border"></span>
                        </div>
                        <small class="form-text text-danger" v-if="has_error && errors.postcode" v-html="errors.postcode.join('<br />')"></small>
                    </div>
                  </div>
                  <div class="col-sm">
                    <div class="form-group" :class="{ 'has-error': has_error && errors.city }">
                        <label for="register-city">{{'label-city'|t}} <span class="required">*</span></label>
                        <div class="input-wrapper">
                          <input type="text" id="register-city" class="form-control" placeholder="Differdange" v-model="city">
                          <span class="focus-border"></span>
                        </div>
                        <small class="form-text text-danger" v-if="has_error && errors.city" v-html="errors.city.join('<br />')"></small>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group" :class="{ 'has-error': has_error && errors.countrycode }">
                        <label for="register-countrycode">{{'label-country'|t}} <span class="required">*</span></label>
                        <div class="select-wrapper">
                          <b-form-select id="register-countrycode" v-model="countrycode" :options="countrycodes" :plain="true" />
                          <span class="focus-border"></span>
                        </div>
                        <small class="form-text text-danger" v-if="has_error && errors.countrycode" v-html="errors.countrycode.join('<br />')"></small>
                    </div>
                  </div>
                </div>

                </template>

                  <div class="row">
                  <div class="col-md-12 pb-1 pt-1 pt-md-0 pb-md-0">
                    <div class="form-group checkbox-wrapper" :class="{ 'has-error': has_error && errors.agreerules }">
                      <b-form-checkbox id="agreerules" name="agreerules" value="agreerules" unchecked-value="agreerules">
                        {{'agree-rules'|t}} <span class="required">*</span>
                      </b-form-checkbox>
                      <small class="form-text text-danger" v-if="has_error && errors.agreerules" v-html="errors.agreerules.join('<br />')"></small>
                    </div>

                    <div class="form-group checkbox-wrapper" :class="{ 'has-error': has_error && errors.agreeprivacy }">
                      <b-form-checkbox id="agreeprivacy" name="agreeprivacy" value="agreeprivacy" unchecked-value="agreeprivacy" class="cart-agreerules">
                        {{'agree-privacy'|t}} <div v-html="$t('agree-privacy-links')"></div>
                        <span class="required">*</span>
                      </b-form-checkbox>
                      <small class="form-text text-danger" v-if="has_error && errors.agreeprivacy" v-html="errors.agreeprivacy.join('<br />')"></small>
                    </div>

                    <div class="form-group checkbox-wrapper" :class="{ 'has-error': has_error && errors.agreedata }">
                      <b-form-checkbox id="agreedata" name="agreedata" value="agreedata" unchecked-value="agreedata">
                        {{'agree-data'|t}}
                      </b-form-checkbox>
                      <small class="form-text text-danger" v-if="has_error && errors.agreedata" v-html="errors.agreedata.join('<br />')"></small>
                    </div>
                  </div>
                </div>


                <button type="submit" class="btn btn-primary btn-submit"><span>{{ 'submit-btn' | t }}</span></button>
              </form>

            </div>
          </div>
        </div>

        <div class="ml-auto col-md-4 col-lg-3 sidebar-right pt-md-4 pt-3">
          <h3 class="left-bullet" v-html="$t('sidebar-title-01')"></h3>
          <p class="br-title" v-html="$t('sidebar-text-01')"></p>
          <router-link class="btn" to="/login"><span>{{ 'btn-sidebar' | t }}</span></router-link>
        </div>
      </div>

    </div>
	</layout-component>
</template>
<script>
  export default {
    data() {
      return {
        name: '',
        surname: '',
        email: '',
        email_confirmation: '',
        password: '',
        password_confirmation: '',
        phone: '',
        company: '',
        vat: '',
        address: '',
        address2: '',
        postcode: '',
        city: '',
        countrycode: 'LU',
        countrycodes: [],
        has_error: false,
        error: '',
        errors: {},
        success: false,
        isApp: false,
      }
    },
    mounted() {
      this.countrycodes = this.$store.countryCodes;
      $('.title-anim-wrapper:in-viewport').addClass('in-viewport');
        Vue.axios.get('/auth/user').then( ({data}) => {
            if(data.data){
                this.$router.push('book');
            }
        })

        this.isApp = window.isApp;
    },

    methods: {
      register() {
        var app = this
        this.$auth.register({
          data: {
            name: this.name,
            surname: this.surname,
            email: this.email,
            email_confirmation: this.email_confirmation,
            password: this.password,
            password_confirmation: this.password_confirmation,
            phone: this.phone,
            company: this.company,
            vat: this.vat,
            address: this.address,
            address2: this.address2,
            postcode: this.postcode,
            city: this.city,
            countrycode: this.countrycode,
            isApp: this.isApp,
            locale: this.$i18n.locale,
          },
          autoLogin: false,
          rememberMe: false,
          success: function () {
            app.success = true
            // handle redirection
            this.$router.push('register-success')
          },
          error: function (res) {
            app.has_error = true
            app.error = res.response.data.error
            app.errors = res.response.data.errors || {}
            setTimeout(function(){
              animateScrollTo(document.querySelector('.' +
                  ''), {
                offset: -200,
                passive: true
              });
          }, 50);
          }
        })
      }
    }
  }
</script>

<i18n>
    {
      "en": {
        "title-banner": "<span class='title-anim-wrapper'><span class='title-anim td'>Create an</span></span> <span class='title-anim-wrapper'><span class='title-anim td-2'>account</span></span>",
        "subtitle-01": "Create a Sonotron account to manage all of rehearsal bookings in one place and easily switch between your desktop and mobile. <br /><strong>Easily unlock the Sonotron universe today</strong>.",
        "error-title-01": "Validation error",
        "error-text-01": "Please see below. ",
        "error-title-02": "Error.",
        "error-text-02": "Unable to register for now. Please try again later or contact us.",
        "title-01": "<span class='title-anim-wrapper'><span class='title-anim td-3'>Who you are</span></span>",
        "title-02": "<span class='title-anim-wrapper'><span class='title-anim'>Where you work</span></span>",
        "title-03": "<span class='title-anim-wrapper'><span class='title-anim'>Where you live</span></span>",
        "text-password": "Please leave the fields blank unless you want to change your password",
        "label-firstname": "First name",
        "label-lastname": "Last name",
        "label-email": "Email",
        "label-email-confirmation": "Email confirmation",
        "label-optional": "(optional)",
        "label-phone-number": "Phone number",
        "label-password": "Password",
        "label-password-confirmation": "Password confirmation",
        "label-company-name": "Organisation",
        "label-vat-number": "VAT number",
        "label-address": "Address",
        "label-address-supplement": "Address supplement",
        "label-postcode": "Postcode",
        "label-city": "City",
        "label-country": "Country",
        "agree-rules": "By creating your account, you agree to Sonotron Terms of use and agree to respect the places.",
        "agree-data": "I agree to the processing of my personal data by Sonotron for the subscribing of the newsletter and sending me information from time to time that may be of interest.",
        "agree-privacy": "By creating your account, you agree to Sonotron",
        "agree-privacy-links": "<a href='/privacy-policy' target='_blank'>Privacy Policy</a> and <a href='/cookies-policy' target='_blank'>Cookies policy</a>",
        "submit-btn": "Create my account",
        "sidebar-title-01": "<span class='title-anim-wrapper'><span class='title-anim td-4'>Already have an account?</span></span>",
        "sidebar-text-01": "Hey, tune chasers & beat makers. <br />We’ve missed you.",
        "btn-sidebar": "Login"
      },
      "fr": {
        "title-banner": "<span class='title-anim-wrapper'><span class='title-anim td'>Creer un</span></span> <span class='title-anim-wrapper'><span class='title-anim td-2'>compte</span></span>",
        "subtitle-01": "Créez un compte pour gérer et consulter le détail de vos réservations facilement, sur ordinateur comme sur mobile. <br /><strong>Vous avez l’univers du Sonotron à portée de main</strong>.",
        "error-title-01": "Erreur de validation",
        "error-text-01": "Voir ci-dessous. ",
        "error-title-02": "Erreur.",
        "error-text-02": "L’inscription est impossible pour l’instant. Veuillez réessayer plus tard ou nous contacter.",
        "title-01": "<span class='title-anim-wrapper'><span class='title-anim td-3'>Qui vous etes</span></span>",
        "title-02": "<span class='title-anim-wrapper'><span class='title-anim'>Ou vous travaillez</span></span>",
        "title-03": "<span class='title-anim-wrapper'><span class='title-anim'>Ou vous habitez</span></span>",
        "text-password": "Veuillez laisser ces champs vierges, sauf si vous souhaitez modifier votre mot de passe.",
        "label-firstname": "Prénom",
        "label-lastname": "Nom",
        "label-email": "Adresse email",
        "label-email-confirmation": "Confirmation email",
        "label-optional": "(facultatif)",
        "label-phone-number": "Numéro de téléphone",
        "label-password": "Mot de passe",
        "label-password-confirmation": "Confirmation mot de passe",
        "label-company-name": "Société",
        "label-vat-number": "Numéro de TVA",
        "label-address": "Adresse postale",
        "label-address-supplement": "Complément d’adresse postale",
        "label-postcode": "Code postal",
        "label-city": "Ville",
        "label-country": "Pays",
        "agree-rules": "En vous créant un compte, vous acceptez les conditions d’utilisation du Sonotron et vous engagez à respecter les locaux.",
        "agree-data": "Je consens au traitement de mes données à caractère personnel par le Sonotron dans le cadre de mon abonnement au bulletin d’information et de sa communication ponctuelle d’informations susceptibles de m’intéresser.",
        "agree-privacy": "En vous créant un compte, vous acceptez",
        "agree-privacy-links": "la <a href='/privacy-policy' target='_blank'>politique de confidentialité</a> et la <a href='/cookies-policy' target='_blank'>politique relative aux cookies</a> du Sonotron.",
        "submit-btn": "Creer un compte",
        "sidebar-title-01": "<span class='title-anim-wrapper'><span class='title-anim td-4'>Vous avez deja un compte ?</span></span>",
        "sidebar-text-01": "Hey, tune chasers & beat makers. <br />Vous nous avez manqué&nbsp;!",
        "btn-sidebar": "Se connecter"
      }
    }

  </i18n>
